module.exports = __webpack_public_path__ + "img/trello.b4207086.png";